import { SectionTitle } from './SectionTitle'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { motion } from 'framer-motion'
import { fadeUp, scaleIn, staggerContainer, viewportOnce } from '@/lib/animations'

const appScreens = [
  { id: 1, title: 'Home Screen', image: '/images/home-screen-phone.webp' },
  { id: 2, title: 'Product Details', image: '/images/product-details-phone.webp' },
  { id: 3, title: 'Cart & Checkout', image: '/images/cart-and-cheeckout-phone.webp' },
  { id: 4, title: 'Order Tracking', image: '/images/order-tracking-phone.webp' },
]

export function AppPreviewSection() {
  return (
    <section id="preview" className="py-6 md:py-10 lg:py-12">
      <div className="wrapper">
        {/* Section Title */}
        <motion.div
          className="mb-12 md:mb-16"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <SectionTitle
            badge="APP PREVIEW"
            title="A Glimpse Inside the App"
            subtitle="Beautifully designed screens for a premium shopping experience."
            centered
          />
        </motion.div>

        {/* Swiper Slider */}
        <motion.div
          className="relative"
          variants={scaleIn}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <Swiper
            modules={[Pagination]}
            pagination={{
              el: '.swiper-pagination-custom',
              clickable: true,
              bulletClass: 'swiper-pagination-bullet-custom',
              bulletActiveClass: 'swiper-pagination-bullet-active-custom',
            }}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 16 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1024: { slidesPerView: 3, spaceBetween: 24 },
              1240: { slidesPerView: 4, spaceBetween: 24 },
            }}
            className="app-preview-swiper"
          >
            {appScreens.map((screen) => (
              <SwiperSlide key={screen.id}>
                <motion.div
                  className="flex flex-col items-center gap-4"
                  whileHover={{ y: -8, transition: { duration: 0.3, ease: 'easeOut' } }}
                >
                  <img
                    src={screen.image}
                    alt={screen.title}
                    className="w-full h-full object-cover"
                  />
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Pagination */}
          <div className="swiper-pagination-custom flex justify-center gap-2 mt-8" />
        </motion.div>
      </div>

      <style>{`
        .swiper-pagination-bullet-custom {
          width: 8px;
          height: 8px;
          background-color: var(--border-light);
          border-radius: 50%;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .swiper-pagination-bullet-active-custom {
          background-color: var(--primary);
        }
      `}</style>
    </section>
  )
}
